export default {

  data () {
    return {
      stateName: '',
sidebar:false
    }
  },
  mounted () {
    this.stateName = this.$route.name
let context =this
    this.$router.app.$on('notification_close',function(){
      context.toggleSidebar()

    })



  },
  watch: {
    '$route' (to, from) {
      this.stateName = to.name
    }
  },
  methods: {

    toggleSidebar()
    {
      this.sidebar = !this.sidebar
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/NotificationSidebar/notification_sidebar.controller.js